import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NzImage, NzImageService } from 'ng-zorro-antd/image';
import { TicketApiService } from 'src/app/services/api/ticket-api.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-support-progress-dialog',
  templateUrl: './support-progress-dialog.component.html',
  styleUrls: ['./support-progress-dialog.component.scss'],
})
export class SupportProgressDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private api: TicketApiService,
    private image: NzImageService,
    private message: MessageService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.getProblemTicket();
  }

  loading = false;
  info: any;
  async getProblemTicket() {
    try {
      this.loading = true;
      const r = await this.api.getProblemTicket(this.data);
      this.info = r.data;
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  preview(img: any) {
    if (!img) {
      return;
    }
    const image: NzImage = {
      src: img,
    };
    this.image.preview([image]);
  }

  status(txt: string) {
    const m: any = {
      submitted: '已提交',
      processing: '处理中',
      waiting_confirmation: '待确认',
      done: '已完成',
    };
    return m[txt] || null;
  }

  loadingBtn = false;
  async confirm() {
    try {
      this.loading = true;
      const r = await this.api.confirmProblemTicket(this.data);
      if (r.status === 0) {
        this.message.open('确认成功');
        this.router.navigateByUrl(this.router.url);
        this.router
          .navigateByUrl('/', { skipLocationChange: true })
          .then(() => {
            this.router.navigate(['/user/profile/form']);
          });
      } else {
        this.message.warn('确认失败');
      }
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  async unconfirm() {
    try {
      this.loading = true;
      const r = await this.api.reopenProblemTicket(this.data);
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/user/profile/form']);
      });
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }
}
